module.exports = __webpack_public_path__ + "static/media/CD.7cde7ee6.png";